@if (isLoading) {
  <app-loading-spinner [message]="'Loading shipment details'"></app-loading-spinner>
} @else {
  @if (shipment) {
    <div class="container-fluid">
      <div class="col-12 px-0 mb-4">
        <div class="card p-0 border-0">
          <div class="card-body p-3">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
              <div class="d-flex align-items-center gap-3">
                <i class="card-title bi bi-arrow-left me-2 cursor-pointer" (click)="goBack()"></i>
                <div>
                  <h5 class="mb-0 fw-bold">Shipment #{{ shipment.shipment_number }}</h5>
                  <span class="text-muted">{{ shipment.created_at | date: 'mediumDate' }}</span>
                </div>
              </div>

              <div class="d-flex gap-2 flex-wrap">
                @if (canAssignTransporter) {
                  <button class="btn btn-sm btn-soft-primary" (click)="openAssignTransporterModal()">
                    <i class="bi bi-person-badge"></i>
                    {{ shipment.transporter ? 'Change Transporter' : 'Assign Transporter' }}
                  </button>
                }
                @if (canMarkDispatched) {
                  <button class="btn btn-sm btn-soft-primary" (click)="openMarkDispatchedModal()">
                    <i class="bi bi-truck"></i>
                    Mark Dispatched
                  </button>
                }
                @if (canMarkDelivered) {
                  <button class="btn btn-sm btn-soft-primary" (click)="openMarkDeliveredModal()">
                    <i class="bi bi-check2-circle me-1"></i>
                    Mark Delivered
                  </button>
                }
              </div>
            </div>

            <div class="row g-4">
              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Order</span>
                    <div class="mt-1">
                      <a [routerLink]="['/orders', shipment.order.id]" class="text-decoration-none">
                        #{{ shipment.order.order_number }}
                      </a>
                    </div>
                    <span class="text-muted">{{ OrderTypeTexts[shipment.order.order_type] || '-' }}</span>
                  </div>
                </div>
              </div>

              @if (shipment.order.dealer) {
                <div class="col-lg-3 col-md-6">
                  <div class="d-flex align-items-start gap-3">
                    <div class="flex-grow-1">
                      <span>Customer / Dealer</span>
                      <div class="mt-1">{{ shipment.order.dealer.shop_name }}</div>
                      <span class="text-muted">
                        {{ shipment.order.dealer.first_name }} {{ shipment.order.dealer.last_name }}
                      </span>
                    </div>
                  </div>
                </div>
              }

              @if (shipment.employee) {
                <div class="col-lg-3 col-md-6">
                  <div class="d-flex align-items-start gap-3">
                    <div class="flex-grow-1">
                      <span>Employee</span>
                      <div class="mt-1">{{ shipment.employee.full_name || '-' }}</div>
                      <span class="text-muted">{{ shipment.employee.employee_number }}</span>
                    </div>
                  </div>
                </div>
              }

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Transporter</span>
                    @if (shipment.transporter) {
                      <div class="mt-1">
                        <i class="bi bi-truck text-muted me-1"></i>
                        {{ shipment.transporter.first_name }} {{ shipment.transporter.last_name }}
                      </div>
                      <span class="text-muted">
                        {{ shipment.transporter.vehicle_number }}
                        @if (shipment.transporter.phone_number) {
                          &middot; {{ shipment.transporter.phone_number }}
                        }
                      </span>
                    } @else {
                      <div class="mt-1 text-muted">Not assigned</div>
                    }
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Dispatch Date</span>
                    <div class="mt-1">
                      {{ shipment.dispatch_date ? (shipment.dispatch_date | date: 'dd MMM yyyy') : '-' }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>
                      {{ shipment.status === ShipmentStatus.DELIVERED ? 'Delivery Date' : 'Expected Delivery' }}
                    </span>
                    <div class="mt-1">
                      {{ shipment.delivery_date ? (shipment.delivery_date | date: 'dd MMM yyyy') : '-' }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Dispatch requested date</span>
                    <div class="mt-1">{{ shipment.order.dispatch_requested_date || '-' }}</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Delivery address</span>
                    <div class="mt-1">{{ shipment.order.delivery_address || '-' }}</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Tracking Number</span>
                    <div class="mt-1">{{ shipment.tracking_number || '-' }}</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Remarks</span>
                    <div class="mt-1">{{ shipment.remarks || '-' }}</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Shipment Status</span>
                    <div class="mt-1">
                      <span
                        class="app-badge"
                        [ngClass]="{
                          'badge-secondary': shipment.status === ShipmentStatus.PENDING,
                          'badge-warning':
                            shipment.status === ShipmentStatus.PACKED || shipment.status === ShipmentStatus.IN_TRANSIT,
                          'badge-primary': shipment.status === ShipmentStatus.DISPATCHED,
                          'badge-success': shipment.status === ShipmentStatus.DELIVERED,
                          'badge-danger': shipment.status === ShipmentStatus.CANCELLED,
                        }">
                        {{ shipment.status | titlecase }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Total Quantity</span>
                    <div class="fw-bold mt-1">
                      {{ totalBoxes }}
                      <span class="text-muted fw-normal">Boxes</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipment Items -->
      <div class="col-12 px-0 mb-4">
        <div class="card border-0 p-0">
          <div class="card-header bg-white border-bottom fw-bold">
            Shipment Items
            <span class="badge bg-secondary ms-2">{{ shipment.items.length }}</span>
          </div>

          <div class="card-body p-3">
            @if (!shipment.items.length) {
              <p class="text-muted mb-0">This shipment has no items.</p>
            } @else {
              <div class="table-responsive">
                <table class="table table-hover align-middle mb-0">
                  <thead class="text-muted">
                    <tr>
                      <th>Product</th>
                      <th>Batch</th>
                      <th>MFG Date</th>
                      <th>EXP Date</th>
                      <th>Production</th>
                      <th class="text-end">Boxes</th>
                    </tr>
                  </thead>

                  <tbody>
                    @for (item of shipment.items; track item.id) {
                      <tr>
                        <td>
                          <div class="fw-medium">{{ getProductTitle(item.order_item) }}</div>
                          <span class="text-muted">{{ getPackagingLabel(item.order_item) }}</span>
                        </td>
                        <td>
                          @if (item.batch_info?.batch_number) {
                            <span class="fw-medium">{{ item.batch_info!.batch_number }}</span>
                          } @else {
                            <span class="text-muted">-</span>
                          }
                        </td>
                        <td>
                          {{
                            item.batch_info?.manufacturing_date
                              ? (item.batch_info!.manufacturing_date | date: 'dd MMM yyyy')
                              : '-'
                          }}
                        </td>
                        <td>
                          {{
                            item.batch_info?.expiry_date ? (item.batch_info!.expiry_date | date: 'dd MMM yyyy') : '-'
                          }}
                        </td>
                        <td>
                          <span class="text-muted">{{ item.batch_info?.production_number || '-' }}</span>
                        </td>
                        <td class="text-end fw-medium">{{ item.box_quantity }}</td>
                      </tr>
                    }
                  </tbody>

                  <tfoot>
                    <tr class="border-top">
                      <td colspan="5" class="text-end text-muted">Total</td>
                      <td class="text-end fw-bold">{{ totalBoxes }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <app-info-alert>{{ NO_SHIPMENT_DETAILS_FOUND_ALERT_MSG }}</app-info-alert>
  }
}

<!-- Assign Transporter Modal -->
<ng-template #transporterModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Assign Transporter</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="text-muted small mb-3">
      Shipment
      <strong>#{{ shipment?.shipment_number }}</strong>
    </p>
    @if (isTransportersLoading) {
      <app-loading-spinner [message]="'Loading transporters...'" />
    } @else {
      <label class="form-label fw-bold small">Select Transporter</label>
      <ng-select
        [items]="transporters"
        [(ngModel)]="selectedTransporterId"
        bindValue="id"
        placeholder="Search transporter...">
        <ng-template ng-label-tmp let-item="item">
          {{ item.first_name }} {{ item.last_name }} &middot; {{ item.vehicle_number }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="fw-semibold">{{ item.first_name }} {{ item.last_name }}</div>
          <small class="text-muted">{{ item.vehicle_number }} &middot; {{ item.phone_number }}</small>
        </ng-template>
      </ng-select>
    }
  </div>
  <div class="modal-footer border-0">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button
      class="btn btn-primary"
      [disabled]="!selectedTransporterId || isActionLoading"
      (click)="confirmAssignTransporter()">
      @if (isActionLoading) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      }
      Assign
    </button>
  </div>
</ng-template>

<!-- Mark Dispatched Modal -->
<ng-template #dispatchModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Mark as Dispatched</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="text-muted small mb-3">
      Shipment
      <strong>#{{ shipment?.shipment_number }}</strong>
    </p>
    <label class="form-label fw-bold small">
      Expected Delivery Date
      <span class="text-danger">*</span>
    </label>
    <input type="date" class="form-control" [(ngModel)]="expectedDeliveryDate" [min]="today" />
  </div>
  <div class="modal-footer border-0">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button class="btn btn-primary" [disabled]="!expectedDeliveryDate || isActionLoading" (click)="confirmDispatch()">
      @if (isActionLoading) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      }
      <i class="bi bi-truck me-1"></i>
      Confirm Dispatch
    </button>
  </div>
</ng-template>

<!-- Mark Delivered Modal -->
<ng-template #deliveryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Mark as Delivered</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="text-muted small mb-3">
      Shipment
      <strong>#{{ shipment?.shipment_number }}</strong>
    </p>
    <label class="form-label fw-bold small">
      Actual Delivery Date
      <span class="text-danger">*</span>
    </label>
    <input type="date" class="form-control" [(ngModel)]="deliveryDate" [max]="today" />
  </div>
  <div class="modal-footer border-0">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button class="btn btn-primary" [disabled]="!deliveryDate || isActionLoading" (click)="confirmDelivery()">
      @if (isActionLoading) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      }
      <i class="bi bi-check2-circle me-1"></i>
      Confirm Delivery
    </button>
  </div>
</ng-template>
